import _ from 'lodash'
import { Record } from 'immutable'

import {
    OPEN_RIBBON_DROPDOWN_MENU,
    CLOSE_RIBBON_DROPDOWN_MENU,
    TOGGLE_RIBBON_DROPDOWN_MENU,
    ACTIVE_RIBBON_DROPDOWN_ITEM,
} from './constants'

const DropDownRecord = new Record({
    active: null,
    open: false,
})

export default (state = new DropDownRecord(), action, dropDownName) => {
    switch (action.type) {
        case OPEN_RIBBON_DROPDOWN_MENU: {
            return state.setIn([dropDownName, 'open'], true)
        }
        case CLOSE_RIBBON_DROPDOWN_MENU: {
            return state.setIn([dropDownName, 'open'], false)
        }
        case TOGGLE_RIBBON_DROPDOWN_MENU: {
            const open = state.getIn([dropDownName, 'open'], false)

            return state.setIn([dropDownName, 'open'], !open)
        }
        case ACTIVE_RIBBON_DROPDOWN_ITEM: {
            const name = _.get(action, 'data.name', null)

            return state.setIn([dropDownName, 'active'], name)
        }
        default:
            return state
    }
}
